import React, { useEffect, useRef, useState } from "react";
import {
  colors2,
  formatCamelCaseToSentenceCase,
  List,
  TabBarV2,
} from "oolib";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";
import FilterModule from "../../../discovery/FilterModule";
import {
  getValidBreakdownFields,
} from "../../InsightMatrix/utils/getValidFieldsForQuantViz";
import {
  SideFilterHeaderStyled,
  StyledFilterHeaderInnerWrapper,
} from "@/components/discovery/FilterModule/comps/AsideFilter/styled";
import { TabBarStyle2 } from "oolib/dist/v2/components/TabBar";
import { BreakdownModule } from "./BreakdownModule";

const getAppropriateBlockLabel = (bl) =>
  bl.props?.shortLabel ||
  bl.props?.label ||
  formatCamelCaseToSentenceCase(bl.valuePath.replace("main.", ""));

export const DataPivotSidebar = ({
  pivotableBlocks,
  activeBlock,
  setActiveBlock,
  subActiveBlock,
  setSubActiveBlock,
  filterConfig,
  activeFilters,
  setActiveFilters,
  contentTypes,
}) => {

  // Count active filters - use activeFilters.length (same approach as OverviewDashboard)
  // This counts each filter object as 1, regardless of whether values is an array or object
  let activeFiltersCount = activeFilters.length;

  const sidebarTabOps = [
    { value: "formFields", display: "Fields" },
    { value: "filters", display: "Filters", message: activeFiltersCount ? activeFiltersCount : undefined },
    { value: "breakDown", display: "Breakdown", message: subActiveBlock ? 1 : undefined },
  ];
  
  const [activeSidebarTab, setActiveSidebarTab] = useState(
    sidebarTabOps[0].value
  );

  const ref_tabbar = useRef(null);
  const [tabbarHeight, setTabbarHeight] = useState("auto");
  
  useEffect(() => {
    if (ref_tabbar.current) {
      const height = ref_tabbar.current.getBoundingClientRect()?.height;
      setTabbarHeight(height + "px");
    }
  }, [activeSidebarTab]);

  const renderFormFieldsTab = () => (
    <div
      style={{
        height: `calc(100% - ${tabbarHeight})`,
        overflow: "auto",
      }}
    >
      <List
        options={pivotableBlocks || []}
        value={activeBlock}
        onChange={(k, v) => setActiveBlock(v)}
        disableShadow
      />
    </div>
  );

  const renderFiltersTab = () => (
    <div style={{ height: `calc(100% - ${tabbarHeight})` }}>
      <FilterModule
        filterConfig={filterConfig}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        usedIn={"dataPivot"}
        contentTypes={contentTypes}
      />
    </div>
  );

  const renderBreakdownTab = () => (
    <div
      style={{
        height: `calc(100% - ${tabbarHeight})`,
        overflow: "auto",
      }}
    >
      <BreakdownModule
        options={getValidBreakdownFields(pivotableBlocks || [])}
        value={subActiveBlock}
        onChange={(k,v) => setSubActiveBlock(v)}
      />
    </div>
  );

  const renderActiveTab = () => {
    switch (activeSidebarTab) {
      case "formFields":
        return renderFormFieldsTab();
      case "filters":
        return renderFiltersTab();
      case "breakDown":
        return renderBreakdownTab();
      default:
        return renderFormFieldsTab();
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <div ref={ref_tabbar} style={{ padding: "0.6rem 1.4rem", borderBottom: `1px solid ${colors2.grey10}`, position: "sticky", top: 0, zIndex: 1, backgroundColor: "white" }}>
        <TabBarStyle2
          options={sidebarTabOps}
          value={activeSidebarTab}
          onChange={(k, v) => setActiveSidebarTab(v)}
          saveValueAsString
        />
      </div>
      {renderActiveTab()}
    </div>
  );
}; 